module.exports = __webpack_public_path__ + "media/KikiG2.fd5f33dd.mp3";